import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';

const { Content } = Layout;
const style = require('./ApprovalHierarchyOverviewPage.less');

class ApprovalHierarchyOverviewPage extends React.Component<any, any> {
	handleTabChange = (key) => {
		const { history, userType } = this.props;
		history.push(`/${userType}/approvalHierarchies/overview/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	render() {
		const { companyConfig, userType, currentUser } = this.props;
		const isInternalTechOrBuyer = isBuyerOrInternalTech(currentUser);

		const tabs = [
			...(isInternalTechOrBuyer
				? [
						{
							key: 'rules/workOrder',
							name: 'Work Order Rules',
						},
						{
							key: 'rules/quote',
							name: 'Quote Rules',
						},
						{
							key: 'rules/invoice',
							name: 'Invoice Rules',
						},
				  ]
				: []),
			...(userType === ROLE_TYPES.SUPPLIER
				? [
						{
							key: 'rules/purchaseRequest',
							name: 'Purchase Request Rules',
						},
				  ]
				: []),
			{
				key: 'templates',
				name: 'Approval Hierarchies',
			},
		];

		return (
			<div>
				<ScrollToTopOnMount />
				<div>
					<Route
						path={`/${userType}/approvalHierarchies/overview`}
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: `/${userType}/approvalHierarchies/overview/rules/workOrders`,
								}}
							/>
						)}
					/>
					<Content className="supplierWorkOrdersPage" style={{ padding: '0 0.5em' }}>
						<div
							style={{
								margin: '0 -8px',
								padding: '24px',
								paddingBottom: 0,
								background: nullSafeGet('detail.config.theme.navblock', companyConfig),
								marginBottom: 8,
							}}
						>
							<div
								style={{
									marginBottom: 24,
								}}
							>
								<h4
									style={{
										color: 'rgba(255, 255, 255, 0.9)',
										marginRight: 8,
										marginBottom: 0,
									}}
								>
									Approvals
								</h4>
							</div>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
						</div>
						{this.props.childRoutes.map((r, i) => (
							<RouteWithSubRoutes key={i} {...r} />
						))}
					</Content>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
	userType: state.session.userType,
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({});
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ApprovalHierarchyOverviewPage)
);
